/**
 * Algolia configuration
 * Credentials are injected via Twig into a global variable
 */

const ALGOLIA_DEBUG = false;

export function algoliaLog(...args) {
  if (ALGOLIA_DEBUG) console.log(...args);
}

// Default config - will be overridden by window.algoliaConfig if available
const defaultConfig = {
  app_id: '',
  api_key: '',
  indices: {
    robots: '',
    robodrills: '',
    robocuts: '',
    roboshots: '',
    cncs: '',
    software: '',
    globalSearch: '',
    allProducts: '',
    accessories: '',
    robotAndGo: '',
  },
};

// Merge with window config if available (set by Twig template)
const config = window.algoliaConfig || defaultConfig;

const algoliaConfig = {
  app_id: config.app_id,
  api_key: config.api_key,
};

export const robotsConfig = {
  ...algoliaConfig,
  index: config.indices?.robots || '',
};

export const robodrillsConfig = {
  ...algoliaConfig,
  index: config.indices?.robodrills || '',
};

export const cncsConfig = {
  ...algoliaConfig,
  index: config.indices?.cncs || '',
};

export const softwareConfig = {
  ...algoliaConfig,
  index: config.indices?.software || '',
};

export const globalSearchConfig = {
  ...algoliaConfig,
  index: config.indices?.globalSearch || '',
};

export const robocutsConfig = {
  ...algoliaConfig,
  index: config.indices?.robocuts || '',
};

export const roboshotsConfig = {
  ...algoliaConfig,
  index: config.indices?.roboshots || '',
};

export const allProductsConfig = {
  ...algoliaConfig,
  index: config.indices?.allProducts || '',
};

export const accessoriesConfig = {
  ...algoliaConfig,
  index: config.indices?.accessories || '',
};

export const robotAndGoConfig = {
  ...algoliaConfig,
  index: config.indices?.robotAndGo || '',
};
